import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { IMAGES } from "../lib/data";

export default function CTASection() {
  return (
    <section
      data-testid="cta-section"
      className="relative isolate overflow-hidden bg-navy"
    >
      <img
        src={IMAGES.cta}
        alt="Offshore vessels operating at sea during sunset"
        loading="lazy"
        decoding="async"
        className="absolute inset-0 h-full w-full object-cover opacity-30"
      />
      <div className="absolute inset-0 bg-navy/70" />
      <div className="relative z-10 mx-auto max-w-4xl px-6 py-28 text-center lg:px-8">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="font-display text-4xl font-extrabold leading-tight tracking-tight text-white sm:text-5xl lg:text-6xl"
        >
          Let's Support Your Next Offshore Project
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="mx-auto mt-6 max-w-2xl text-lg text-white/70"
        >
          Partner with a team that delivers reliable marine logistics and
          qualified offshore professionals, anywhere in the world.
        </motion.p>
        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Link
            to="/quote"
            data-testid="cta-request-quote"
            className="inline-flex w-full items-center justify-center gap-1.5 rounded-sm bg-brandred px-8 py-4 text-base font-semibold text-white transition-colors duration-200 hover:bg-brandred-600 sm:w-auto"
          >
            Request a Quote <ArrowUpRight className="h-5 w-5" />
          </Link>
          <Link
            to="/contact"
            data-testid="cta-contact-team"
            className="inline-flex w-full items-center justify-center gap-1.5 rounded-sm border border-white/25 px-8 py-4 text-base font-semibold text-white transition-colors duration-200 hover:bg-white hover:text-navy sm:w-auto"
          >
            Contact Our Team
          </Link>
        </div>
      </div>
    </section>
  );
}
